import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { LookupListAddPayload, LookupListsResponse } from './lookup-lists.types';

/**
 * The Ops endpoints for `§B6.2`'s lookup lists (FLOW-304).
 *
 * Reading is any Authorised Ops user; adding and removing are the Senior Ops
 * floor, enforced server-side — the page hides the forms below that tier but
 * the server is the gate.
 */
@Injectable({ providedIn: 'root' })
export class LookupListsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/kickstart/ops/lookup-lists`;

  /** Every entry, live and removed, with each list's version. */
  list(): Observable<LookupListsResponse> {
    return this.http.get<LookupListsResponse>(`${this.base}/`);
  }

  /**
   * Add a live term. The server refuses a blank reason, a missing or unknown
   * prompting application (400) and a live duplicate.
   */
  add(payload: LookupListAddPayload): Observable<LookupListsResponse> {
    return this.http.post<LookupListsResponse>(`${this.base}/`, payload);
  }

  /** Remove a live term — a transition on its row, never a delete. Reason and application required. */
  remove(shortId: string, reason: string, promptedBy: string): Observable<LookupListsResponse> {
    return this.http.post<LookupListsResponse>(`${this.base}/${shortId}/remove/`, {
      reason,
      prompted_by: promptedBy,
    });
  }
}
